import { BaseModel } from '../../_base/crud';

export class scoringRecordModel extends BaseModel {
  db: string;
  status_fs: string;
  status_bq: string;
  status: string;
	token: string ;
 
  clear() {
    this.db = '';
    this.status = '';
    this.token = '';
  }

  public scoringRecordModel(x:scoringRecordModel){
    this.status_bq=x.status_bq;
    this.status_fs=x.status_fs
  }
}